import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EmptyObject } from '../../../shared/interfaces/empty-object.interface';
import { IGenerateKeyResult, IPreviousTokensServerResponse } from '../../../shared/interfaces/user-api-key.interface';
import { IntegrationsRestAPI } from './rest/integrations.api';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  constructor(private integrationsRestAPI: IntegrationsRestAPI) {}

  public generateToken(name: string, expiry?: Date, reminderDays?: number): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.generateApikey(name, expiry, reminderDays);
  }

  public generateBrowserExtensionToken(): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.generateBrowserExtensionKey();
  }

  public getPreviousTokensInfo(): Observable<IPreviousTokensServerResponse[]> {
    return this.integrationsRestAPI.getPreviousTokensInfo();
  }

  public revokeToken(name: string): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.revokeApikey(name);
  }

  public generateAmpApiToken(tenantId: string): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.generateAmpApiKey(tenantId);
  }

  public deleteAmpApiToken(tenantId: string): Observable<EmptyObject> {
    return this.integrationsRestAPI.deleteAmpApiKey(tenantId);
  }

  public getAmpApiToken(tenantId: string): Observable<IPreviousTokensServerResponse | null> {
    return this.integrationsRestAPI.getAmpApiKey(tenantId);
  }

  public createScanningAgentApiToken(): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.createScanningAgentApiKey();
  }

  public generateScimApiToken(): Observable<IGenerateKeyResult> {
    return this.integrationsRestAPI.generateScimApiKey();
  }

  public getScimApiToken(): Observable<IPreviousTokensServerResponse | null> {
    return this.integrationsRestAPI.getScimApiKey();
  }
}
